import { render } from "./ProductSellsModal.vue?vue&type=template&id=7e5ba620&scoped=true"
import script from "./ProductSellsModal.vue?vue&type=script&lang=js"
export * from "./ProductSellsModal.vue?vue&type=script&lang=js"

import "./ProductSellsModal.vue?vue&type=style&index=0&id=7e5ba620&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5ba620"]])

export default __exports__